import React from 'react'
import PropTypes from 'prop-types'
import compose from '@shopify/react-compose'
import { withTheme } from 'react-jss'
import classNames from 'classnames'
import styles from './notification-style'
import { withTranslation } from 'react-i18next'

const icon = (status) => {
  switch (status) {
    case 'fail':
      return 'fa-exclamation-triangle'
    default:
      return 'fa-check-circle'
  }
}

const Notification = ({message, status, t, theme, children}) => {
  const classes = styles(theme)
  return (
    <div className={classNames(classes.notification, status)}>
      <span className={classNames(classes.notificationIcon, 'fal', icon(status))} />
      <div className={classes.notificationContent}>
        <span>{t(message)}</span>
        {children}
      </div>
    </div>
  )
}

Notification.propTypes = {
  message: PropTypes.string.isRequired,
  status: PropTypes.string
}

Notification.defaultProps = {
  status: 'success'
}

export default compose(
  withTranslation(),
  withTheme
)(Notification)
